enum ActionTypes {
  MAIN_SET_PAGE = 'ADMIN_DOCUMENTATION_FILE_MAIN_SET_PAGE',
  MAIN_SET_SEARCH = 'ADMIN_DOCUMENTATION_FILE_MAIN_SET_SEARCH',
  MAIN_SET_TAGS = 'ADMIN_DOCUMENTATION_FILE_MAIN_SET_TAGS',
  MAIN_SET_ACTIVE_COLUMNS = 'ADMIN_DOCUMENTATION_FILE_MAIN_SET_ACTIVE_COLUMNS ',
  MAIN_SET_TAKE = 'ADMIN_DOCUMENTATION_FILE_MAIN_SET_TAKE',
}

export default ActionTypes;
